function normalizeAiAssessmentStatus(raw: unknown): string {
  if (typeof raw !== "string") return "";
  return raw.trim().toLowerCase().replace(/\s+/g, "_");
}

function isAiStatusInProgress(normalized: string): boolean {
  return (
    normalized === "in_progress" ||
    normalized === "inprogress" ||
    normalized === "running" ||
    normalized === "init"
  );
}

/**
 * Pure helper for AI Impact Assessment grid actions (Assessment Center + modal).
 */
export function getAiImpactAssessmentActionsVisibility(rawStatus: unknown): {
  showReportActions: boolean;
  showRetry: boolean;
} {
  const status = normalizeAiAssessmentStatus(rawStatus);
  if (isAiStatusInProgress(status)) {
    return { showReportActions: false, showRetry: false };
  }
  const isFailed = status === "failed";
  const isPartial = status === "partial";
  return {
    showReportActions: !isFailed,
    showRetry: isFailed || isPartial,
  };
}
